<div class="container">
  <div class="card-list-container">
    <div class="card-container" *ngFor="let recipient of recipients" (click)="setSelectedRecipient(recipient)"
         [ngClass]="recipientClassChecker(recipient)">
      <div class="card-box">
        <div class="card-desc">
          <div class="card-image" [ngStyle]="{'background-image': 'url(./assets/svg/'+recipient.short+'.svg)'}"></div>
          <div class="card-icon">
            <img [src]="'./assets/svg/' + recipient.short +  '_icon.svg'">
          </div>
          <div class="card-name">
            {{recipient.name}}
          </div>
        </div>
        <div class="card-details">
          <div class="details-container">
            <form [formGroup]="recipientForm">
              <div class="detail-box" *ngIf="selectedRecipient?.short == 'vessel'">
                <div class="detail-title">
                  {{'REQUEST.RECIPIENT.LOCATIONTEXT'| translate}}
                </div>
                <div class="detail-options">
                  <ul class="multi-select-btns">
                    <li *ngFor="let location of locations" style="width: 25%">
                      <div class="selector" (click)="selectLocation(location)"
                           [ngClass]="{active: selectedLocation == location.short}">
                        <span>{{'LOCATIONS.' + location.short | translate}}</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="detail-box" *ngIf="selectedRecipient?.short == 'vessel'">
                <div class="detail-title">
                  {{'REQUEST.RECIPIENT.LENGTHTEXT'| translate}}
                </div>
                <div class="detail-options">
                  <div class="w-slider">
                    <div class="slider-text">{{feetValue}} Feet</div>
                    <mat-slider [min]="5" [max]="400" [value]="feetValue" (input)="feetChanged($event)"></mat-slider>
                  </div>
                </div>
              </div>
              <div class="detail-box" *ngIf="selectedRecipient?.short == 'vessel'">
                <div class="detail-title">
                  {{'REQUEST.RECIPIENT.NAMETEXT'| translate}}
                </div>
                <div class="detail-options">
                  <input class="w-input" formControlName="name" name="name"
                         placeholder="Shakespeare IV" [title]="'REQUEST.RECIPIENT.NAMETEXT'| translate">
                </div>
              </div>
              <div class="detail-box">
                <div class="detail-title">
                  {{'REQUEST.RECIPIENT.COMMENTTEXT' | translate}}
                </div>
                <div class="detail-options">
                <textarea class="w-text-area" formControlName="comments" name="comments"
                          [placeholder]="'REQUEST.RECIPIENT.COMMENTPACEHOLDER' | translate"></textarea>
                </div>
              </div>
              <div class="detail-box no-b-margin">
                <div class="detail-options">
                  <button class="w-btn submit-btn" type="button"
                          [disabled]="!recipientForm.valid && selectedRecipient?.short == 'vessel'"
                          (click)="submitStep()">
                    {{'NEXT' | translate}}
                  </button>
                  <button class="w-link-btn" (click)="setSelectedRecipient(null)">{{'TAKEMEBACK' | translate}}</button>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
